import { render, staticRenderFns } from "./SettingMvp.vue?vue&type=template&id=aeed7d54"
import script from "./SettingMvp.vue?vue&type=script&lang=js"
export * from "./SettingMvp.vue?vue&type=script&lang=js"
import style0 from "./SettingMvp.vue?vue&type=style&index=0&id=aeed7d54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports